<template>
    <div class="container tile">
        <div class="bs-docs-grid">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <h1>This page cannot be found.</h1>
                    <div v-if="content" v-html="content"></div>
                    <p v-else>If you think this page should exist, please email our helpdesk at <a class="alert-link" href="mailto:mt_helpdesk@egov.com">mt_helpdesk@egov.com</a> or call our helpdesk at 406-449-3468.</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { asyncComputed } from "@vueuse/core";
import { useMainStore } from "@/mainStore";
export default defineComponent({
    setup() {
        const mainStore = useMainStore();
        return {
            content: asyncComputed(() => mainStore.tenantData?.customNotFoundHtml, null),
        };
    },
});
</script>
